import React from 'react';

function ShoprunnerPdpCTA() {
  return (
    <div className="mt-2 flex w-full justify-center text-center">
      <sr-benefits-shipping></sr-benefits-shipping>
    </div>
  );
}

export default ShoprunnerPdpCTA;
